var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay",class:_vm.overlayClass},[_c('div',{staticClass:"dialog"},[_vm._t("dialog",function(){return [_c('loading-icon'),_vm._v("\n            처리중입니다. 잠시만 기다리세요..\n        ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }